import TagItem, { TagItemProps } from './TagItem';

export type { TagItemProps };
export default TagItem;
